module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-gd-psla-calculator"
  }, [_c('h2', [_vm._v("Mesothelioma General Damages (PSLA) Calculator")]), _vm._v(" "), _c('p', [_vm._v("\n        Welcome to our Mesothelioma General Damages (PSLA) calculator. The calculator shows estimated common law awards\n        according to 'age' and 'duration of symptoms' — the period between onset of the disease\n        and death (or anticipated date of death).\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n        There are two parts to the calculator:\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n        Onset of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.onsetOfSymptoms) + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Duration of symptoms:\n        "), _c('strong', [_vm._v("\n            " + _vm._s(_vm.calculatedDurationOfSymptoms) + " month" + _vm._s(_vm.calculatedDurationOfSymptoms === 1 ? '' : 's') + "\n        ")])]), _vm._v(" "), _c('p', [_vm._v("\n        Age at Death: "), _c('strong', [_vm._v(_vm._s(_vm.ageAtDeath))])]), _vm._v(" "), _c('label', [_vm._v("\n        Duration of Symptoms\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "c-gd-psla-calculator__slider p-dependency-calc__slider"
  }, [_c('vue-slider', {
    ref: "slider",
    attrs: {
      "min": 0,
      "max": 37,
      "real-time": true,
      "clickable": true,
      "piecewise": true,
      "process-style": {
        'backgroundColor': '#4A89E5'
      },
      "tooltip-style": {
        'backgroundColor': '#4A89E5',
        'borderColor': '#4A89E5'
      },
      "formatter": _vm.calculatedDurationOfSymptoms + ' months',
      "label-style": {
        'color': '#fff'
      }
    },
    model: {
      value: (_vm.calculatedDurationOfSymptoms),
      callback: function($$v) {
        _vm.calculatedDurationOfSymptoms = $$v
      },
      expression: "calculatedDurationOfSymptoms"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "u-d-flex u-flex-space-between"
  }, [_c('h2', [_vm._v("Tariff Table")]), _vm._v(" "), _c('button', {
    staticClass: "a-button a-button--smaller",
    on: {
      "click": function($event) {
        return _vm.applyUplift()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.upliftButton ? 'Add' : 'Remove') + " 10% Uplift\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "a-table--short-no-style"
  }, [(_vm.table[50] && !_vm.loading.table) ? _c('table', {
    staticClass: "a-table a-table--full-width a-table--condensed"
  }, [_c('tr', [_c('th', {
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Age (Up to)")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": _vm.table[50].length
    }
  }, [_vm._v("\n                    Duration (months)\n                ")])]), _vm._v(" "), _c('tr', _vm._l((_vm.table[50].length), function(col) {
    return _c('th', [(col === 1) ? _c('span', [_vm._v("0-3")]) : (col === 13) ? _c('span', [_vm._v("37+")]) : _c('span', [_vm._v(_vm._s(col * 3 - 2) + "-" + _vm._s(col * 3))])])
  }), 0), _vm._v(" "), _vm._l((_vm.table), function(tr, age) {
    return _c('tr', [_c('th', [_vm._v(_vm._s(age))]), _vm._v(" "), _vm._l((tr), function(td, index) {
      return _c('td', {
        style: (_vm.getTariffTableTdStyle(index, age)),
        on: {
          "click": function($event) {
            _vm.usePslaAward(_vm.uplift ? Math.round(td * 1.1) : td)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(_vm.currencyFormat(_vm.uplift ? Math.round(td * 1.1) : td, '£', 0)) + "\n                ")])
    })], 2)
  })], 2) : _vm._e()]), _vm._v(" "), (_vm.loading.table) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "c-gd-psla-calculator__disclaimer"
  }, [_vm._v("Data is up-to-date as of " + _vm._s(_vm.currentRpi) + " *")]), _vm._v(" "), _c('h2', [_vm._v("Awards")]), _vm._v(" "), _vm._l((_vm.filteredAwards), function(award) {
    return (!_vm.loading.awards) ? _c('psla-award', {
      attrs: {
        "award": award
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.loading.awards) ? _c('div', [_vm._v("\n        Loading... one moment\n    ")]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("\n            The first is a Tariff Table designed to give a broad brush indication of possible awards and\n            is not intended to substitute a detailed review and consideration of actual awards to\n            properly value any PSLA award. The Tariff Table is based on the 14th Edition of the JC Guidelines.\n        ")]), _vm._v(" "), _c('li', [_vm._v("\n            The second shows actual PLSA awards which most closely fit the selected age and duration\n            of symptoms.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-457cc7e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/dependency/steps/general-damages/GeneralDamagesPslaCalculator.vue
// module id = 1667
// module chunks = 0